/**
 * Pure Lamps Theme — Global JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {
  initCart();
  initForms();
});

/* ── Cart ── */
function initCart() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add item'); });
          return r.json();
        })
        .then(function () {
          updateCartCount();
          showNotification('Added to cart!', 'success');
        })
        .catch(function (err) {
          showNotification(err.message || 'Error adding to cart', 'error');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
    });
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-bubble').forEach(function (el) {
        if (cart.item_count > 0) {
          el.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    })
    .catch(function () {});
}

/* ── Notification ── */
function showNotification(message, type) {
  var el = document.getElementById('notification');
  if (!el) return;
  el.textContent = message;
  el.className = 'notification ' + (type || 'success');
  void el.offsetWidth;
  el.classList.add('show');
  setTimeout(function () { el.classList.remove('show'); }, 3000);
}

/* ── Contact / newsletter forms ── */
function initForms() {
  document.querySelectorAll('.footer-newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showNotification('Thanks for subscribing!', 'success');
      form.reset();
    });
  });
}
